// This function allow to reference chunks
__webpack_require__.k = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/" + {"highlight": "e4d128723677ef7c","katex-0": "b93b4819589097ce","monaco": "574a7041ceae1853","src_app_App_tsx": "fcea177192bf6f4a","src_features_app_components_pages_QuickCssEditorPage_tsx": "844a9cb9b5cf3ec8","src_features_auth_components_CaptchaInterceptor_tsx": "004d5c62e422825b","src_features_code_highlighting_utils_ArboriumThemeBridge_css": "254b4c3eeed76327",}[chunkId] + ".css"
}